import * as Fetch from '../data/Fetch';
import * as utility from '../data/Utility';

const setAllHistoryRecordsType = 'SET_ALL_HISTORY_RECORDS';
const setAllRecordsType = 'SET_ALL_RECORDS';
const setRecentScheduleOrdinalPeriodType = 'SET_RECENT_SCHEDULE_ORDINAL_PERIOD';
const setAllBillablesType = 'SET_ALL_BILLABLES';
const setAllRecordsRejectedByMD = 'SET_ALL_RECORDS_REJECTED_BY_MD';
const setAllRecordsNeedsOverreadType = 'SET_ALL_RECORDS_NEEDS_OVERREAD';
const setAllRecordsNeedsQaType = 'SET_ALL_RECORDS_NEEDS_QA';
const setAllRecordsPatientType = 'SET_ALL_RECORDS_PATIENT';
const setAllRecordsSiteType = 'SET_ALL_RECORDS_SITE';
const setAllRecordsStudyIdType = 'SET_ALL_RECORDS_STUDY_ID';
const setAllCompliancyRowsType = 'SET_ALL_COMPLIANCY_ROWS_TYPE';
const setAllRecordsStudyNameType = 'SET_ALL_RECORDS_STUDY_NAME';
const setAllRecordsUnreadType = 'SET_ALL_RECORDS_UNREAD';
const setBillableItemType = 'SET_BILLABLE_ITEM';
const setRecordType = 'SET_RECORD';
const setRecordsFetchingType = 'SET_RECORDS_FETCHING';
const setRecordsDoRefreshType = 'SET_RECORDS_DO_REFRESH';
const setReportType = 'SET_REPORT';
const setRecordIsScheduledType = 'SET_RECORD_IS_SCHEDULED';
const setRecordScheduleOrdinalType = 'SET_RECORD_SCHEDULE_ORDINAL';
const setRecordSchedulePeriodType = 'SET_RECORD_SCHEDULE_PERIOD';
const setDownloadableDataType = 'SET_DOWNLOADABLE_DATA';

const initialState = {
    all: null,
	allCompliancyRows: null,
	recordList: null,
	billableItems: null,
	allHistoryRecords: null,
    allNeedsOverread: false,
    allRejectedByMD: false,
    allNeedsQa: false,
    allPatientCode: "",
    allPatientId: "",
    allSiteId: "",
    allSiteName: "",
    allStudyId: "",
    allStudyName: "",
    allUnread: false,
    doRefresh: false,
    fetching: false,
    record: null,
    report: null
};

export const recordServiceTypes = {
    event: "Event",
    holter: "Holter",
    twelveLead: "12-Lead"
};

export const recordStatus = {
    initial: 0,
    rejectedByMd: 5,
    needsOverread: 10,
    needsQa: 20,
    final: 30
};

export const recordBillableStatus = {
	TBD: 0,
	NonBillable: 10,
	Billable: 20,
	Finalized: 100
};

export const emptyRecord = {
    comments: "",
	predominantRhythm: "",
	hasAfib: null,
	hasAflutter: null,
	hasAtachy: null,
	isAnalyzable: null,
	isMdNotification: null,
	deviceModel: "",
	deviceSerial: "",
    id: null,
    isMdOverreadComplete: null,
    isMdOverreadRequired: true,
    isQaComplete: null,
    isQaRequired: true,
    isScheduled: null,
    isSymptomatic: null,
    mdOverreadAssignedId: "",
    mdOverreadFindings: "",
    patient: null,
    patientId: "",
    receiveDateTime: null,
    recordDateTime: null,
    serviceType: recordServiceTypes.twelveLead,
    timeZoneOffsetMinutes: null
};

export const emptyEvent = {
    activitiesCodeSet: "",
    activitiesRemark: "",
    analysisClassSet: "",
    analysisRemark: "",
    analysisRhythmSet: "",
    clinicalEvaluationStartDateTime: null,
    clinicalEvaluationUpdateDateTime: null,
    d_recanalysis_key: "",
    measuredHrMax: "",
    measuredHrMean: "",
    measuredHrMin: "",
    measuredHrN: "",
    record: emptyRecord,
    report: null,
    reportNr: "",
    studyReportNr: "",
    symptomsCodeSet: "",
    symptomsRemark: ""
}

export const emptyHolter = {
    description: "",
    findings: "",
	afibLongestDuration: "",
	aflutterLongestDuration: "",
	atachyLongestDuration: "",
	analyzableDuration: "",
	totalDuration: "",
    record: emptyRecord,
    report: null,
};

export const empty12Lead = {
    hr: null,
    pAxis: null,
    pr: null,
    qrs: null,
    qt: null,
    qtc: null,
    qtcB: null,
    qtcF: null,
    rAxis: null,
	hasAfibContinuous: null,
	hasAflutterContinuous: null,
	hasAtachyContinuous: null,
    record: emptyRecord,
    report: null,
    rr: null,
    tAxis: null
};

export const actionCreators = {
    createHolter: (patientId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, true, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl("Records/AddNewHolter");
        const record = recordsState.record;
        const receiveDateTime = utility.getDateTimeJson(record.record.receiveDateTime);
        const recordDateTime = utility.getDateTimeJson(record.record.recordDateTime);
        var body = new FormData();
		let scheduleOrdinal = '';
		if ( record.record.scheduleOrdinal !== undefined && record.record.scheduleOrdinal !== null ) {
			scheduleOrdinal = record.record.scheduleOrdinal;
		}
		let schedulePeriod = '';
		if ( record.record.schedulePeriod !== undefined && record.record.schedulePeriod !== null ) {
			schedulePeriod = record.record.schedulePeriod;
		}
		let scheduleSuffix = '';
		if ( record.record.scheduleSuffix !== undefined && record.record.scheduleSuffix !== null ) {
			scheduleSuffix = record.record.scheduleSuffix;
		}
        body.append("description", record.description);
        appendToForm(body, "findings", record.findings);
        appendToForm(body, "afibLongestDuration", utility.getDurationFromHms(record.afibLongestDuration));
        appendToForm(body, "aflutterLongestDuration", utility.getDurationFromHms(record.aflutterLongestDuration));
        appendToForm(body, "atachyLongestDuration", utility.getDurationFromHms(record.atachyLongestDuration));
        appendToForm(body, "analyzableDuration", utility.getDurationFromHm(record.analyzableDuration));
        appendToForm(body, "totalDuration", utility.getDurationFromHm(record.totalDuration));
        body.append("record[comments]", record.record.comments);
        body.append("record[predominantRhythm]", record.record.predominantRhythm);
        appendToForm(body, "record[hasAfib]", record.record.hasAfib);
        appendToForm(body, "record[hasAflutter]", record.record.hasAflutter);
        appendToForm(body, "record[hasAtachy]", record.record.hasAtachy);
        appendToForm(body, "record[isAnalyzable]", record.record.isAnalyzable);
        appendToForm(body, "record[isMdNotification]", record.record.isMdNotification);
        appendToForm(body, "record[isBillableStatus]", 0 );
        body.append("record[deviceModel]", record.record.deviceModel);
        body.append("record[deviceSerial]", record.record.deviceSerial);
        body.append("record[isMdOverreadRequired]", record.record.isMdOverreadRequired);
        body.append("record[isQaRequired]", record.record.isQaRequired);
        appendToForm(body, "record[isScheduled]", record.record.isScheduled);
        appendToForm(body, "record[isSymptomatic]", record.record.isSymptomatic);
        body.append("record[mdOverreadAssignedId]", record.record.mdOverreadAssignedId);
        body.append("record[patientId]", patientId);
        body.append("record[receiveDateTime]", receiveDateTime);
        body.append("record[recordDateTime]", recordDateTime);
        body.append("record[serviceType]", record.record.serviceType);
        body.append("record[scheduleOrdinal]", scheduleOrdinal );
        body.append("record[schedulePeriod]", schedulePeriod );
        body.append("record[scheduleSuffix]", scheduleSuffix );
        appendToForm(body, "record[timeZoneOffsetMinutes]", record.record.timeZoneOffsetMinutes);
        appendToForm(body, "report", record.report);
        appendToForm(body, "CrfQnA", JSON.stringify(record.crfQnA));
        await Fetch.postForm(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    },

    create12Lead: (patientId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, true, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl("Records/AddNew12Lead");
        const record = recordsState.record;
        const receiveDateTime = utility.getDateTimeJson(record.record.receiveDateTime);
        const recordDateTime = utility.getDateTimeJson(record.record.recordDateTime);
		let scheduleOrdinal = '';
		if ( record.record.scheduleOrdinal !== undefined && record.record.scheduleOrdinal !== null ) {
			scheduleOrdinal = record.record.scheduleOrdinal;
		}
		let schedulePeriod = '';
		if ( record.record.schedulePeriod !== undefined && record.record.schedulePeriod !== null ) {
			schedulePeriod = record.record.schedulePeriod;
		}
		let scheduleSuffix = '';
		if ( record.record.scheduleSuffix !== undefined && record.record.scheduleSuffix !== null ) {
			scheduleSuffix = record.record.scheduleSuffix;
		}
        var body = new FormData();
        appendToForm(body, "hr", record.hr);
        appendToForm(body, "pAxis", record.pAxis);
        appendToForm(body, "pr", record.pr);
        appendToForm(body, "qrs", record.qrs);
        appendToForm(body, "qt", record.qt);
        appendToForm(body, "qtc", record.qtc);
        appendToForm(body, "qtcB", record.qtcB);
        appendToForm(body, "qtcF", record.qtcF);
        appendToForm(body, "rAxis", record.rAxis);
		appendToForm(body, "hasAfibContinuous", record.hasAfibContinuous );
		appendToForm(body, "hasAflutterContinuous", record.hasAflutterContinuous );
		appendToForm(body, "hasAtachyContinuous", record.hasAtachyContinuous );
        body.append("record[comments]", record.record.comments);
        body.append("record[predominantRhythm]", record.record.predominantRhythm);
        appendToForm(body, "record[hasAfib]", record.record.hasAfib);
        appendToForm(body, "record[hasAflutter]", record.record.hasAflutter);
        appendToForm(body, "record[hasAtachy]", record.record.hasAtachy);
        appendToForm(body, "record[isAnalyzable]", record.record.isAnalyzable);
        appendToForm(body, "record[isMdNotification]", record.record.isMdNotification);
        body.append("record[deviceModel]", record.record.deviceModel);
        body.append("record[deviceSerial]", record.record.deviceSerial);
        body.append("record[isMdOverreadRequired]", record.record.isMdOverreadRequired);
        body.append("record[isQaRequired]", record.record.isQaRequired);
        appendToForm(body, "record[isScheduled]", record.record.isScheduled);
        appendToForm(body, "record[isSymptomatic]", record.record.isSymptomatic);
        body.append("record[mdOverreadAssignedId]", record.record.mdOverreadAssignedId);
        body.append("record[patientId]", patientId);
        body.append("record[receiveDateTime]", receiveDateTime);
        body.append("record[recordDateTime]", recordDateTime);
        body.append("record[serviceType]", record.record.serviceType);
        body.append("record[scheduleOrdinal]", scheduleOrdinal );
        body.append("record[schedulePeriod]", schedulePeriod );
        body.append("record[scheduleSuffix]", scheduleSuffix );
        appendToForm(body, "record[timeZoneOffsetMinutes]", record.record.timeZoneOffsetMinutes);
        appendToForm(body, "report", record.report);
        appendToForm(body, "CrfQnA", JSON.stringify(record.crfQnA));
        appendToForm(body, "rr", record.rr);
        appendToForm(body, "tAxis", record.tAxis);
        await Fetch.postForm(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    },

    disposeReport: () => async (dispatch, getState) => {
        const recordsState = getState().records;
        if (recordsState == null) {
            return;
        }
        disposeReportInternal(recordsState.report, dispatch);
    },

    get: (recordId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/GetById?id=${recordId}`);
        var data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setRecordType);
        setFetching(false, dispatch);
    },

    getAll: () => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl("Records/GetAll");
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setAllRecordsType);
        setFetching(false, dispatch);
    },

    getAllByStudy: (studyId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/GetAllByStudy?studyId=${studyId}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setAllRecordsType);
        setAllRecordsStudyId(studyId, dispatch);
        setFetching(false, dispatch);
    },

    getAllCompliancyRows: (studyId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/DownloadJsonCompliancy?studyId=${studyId}`);
        let data = await Fetch.getRequest(url, accountsState.authenticatedToken);
		data = {...data, studyId: studyId };
        setResponse(data, dispatch, setAllCompliancyRowsType);
    },

    GetAllRecordListByPatient: (patientId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/GetAllRecordListByPatient?patientId=${patientId}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setAllHistoryRecordsType);
        setAllHistoryRecords(data, dispatch);
        setFetching(false, dispatch);
    },

    getAllRecordList: () => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/GetAllRecordList`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setAllRecordsType);
    },

    getAllRecordListByStudy: (studyId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/GetAllRecordListByStudy?studyId=${studyId}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setAllRecordsType);
        setAllRecordsStudyId(studyId, dispatch);
        setFetching(false, dispatch);
    },

    getRecentScheduleOrdinalPeriod: (patientId,serviceType) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/GetRecentScheduleOrdinalPeriod?patientId=${patientId}&serviceType=${serviceType}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setRecentScheduleOrdinalPeriodType);
        setRecentScheduleOrdinalPeriod( data, dispatch);
        setFetching(false, dispatch);
    },

    getAllBillables: (studyId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/GetAllBillables?studyId=${studyId}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setAllBillablesType);
        setFetching(false, dispatch);
    },

    getBillableItem: (itemId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        setFetching(true, dispatch);
        const url = await Fetch.getUrl(`Records/GetBillableItem?id=${itemId}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setBillableItemType);
        setFetching(false, dispatch);
    },

    deleteBillableItem: (itemId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/DeleteBillableItem?id=${itemId}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setBillableItemType);
        setFetching(false, dispatch);
    },

    duplicateBillableItem: (itemId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/DuplicateBillableItem?id=${itemId}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setBillableItemType);
        setFetching(false, dispatch);
    },

    getEvent: (recordId, studyId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/GetRecordEventByRecordIdStudyId?recordId=${recordId}&studyId=${studyId}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setRecordType);
        setFetching(false, dispatch);
    },

    getHolter: (recordId, studyId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/GetRecordHolterByRecordIdStudyId?recordId=${recordId}&studyId=${studyId}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setRecordType);
        setFetching(false, dispatch);
    },

    getReport: (recordId, studyId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;

        disposeReportInternal(recordsState.report, dispatch);
        const url = await Fetch.getUrl(`Records/GetReportByIdStudyId?id=${recordId}&studyId=${studyId}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        var report = null;
        if (Fetch.validResponse(data)) {
            report = URL.createObjectURL(data);
        }
        setResponse(report, dispatch, setReportType);
        setFetching(false, dispatch);
    },

    get12Lead: (recordId, studyId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/GetRecord12LeadByRecordIdStudyId?recordId=${recordId}&studyId=${studyId}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setRecordType);
        setFetching(false, dispatch);
    },

    getWithStudyId: (recordId, studyId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/GetByIdStudyId?id=${recordId}&studyId=${studyId}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setRecordType);
        setFetching(false, dispatch);
    },

    getSpreadsheetCompliancy: (studyId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
//        const recordsState = getState().records;
//        if (badState(accountsState, recordsState, false, dispatch)) {
//            return;
//        }

        const url = await Fetch.getUrl(`Records/DownloadSpreadsheetCompliancy?studyId=${studyId}`);
        let data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        dispatch({ type: setDownloadableDataType, data: {data: data, studyId: studyId} });
    },

    reset: () => async (dispatch, getState) => {
        const recordsState = getState().records;
        if (recordsState == null) {
            return;
        }

        const data = initialState.record;
        dispatch({ type: setRecordType, data });
        disposeReportInternal(recordsState.report, dispatch);
    },

    resetAll: () => async (dispatch) => {
        var data = initialState.all;
        dispatch({ type: setAllRecordsType, data });
		data = { recordList: null, billableItems: null };
        dispatch({ type: setAllBillablesType, data });
		data= { allCompliancyRows: null };
        dispatch({ type: setAllCompliancyRowsType, data });
		data = { lastScheduleOrdinal: null, lastSchedulePeriod: null };
        dispatch({ type: setRecentScheduleOrdinalPeriodType, data });
        data = initialState.allNeedsOverread;
        dispatch({ type: setAllRecordsNeedsOverreadType, data });
        data = initialState.allRejectedByMD;
        dispatch({ type: setAllRecordsRejectedByMD, data });
        data = initialState.allNeedsQa;
        dispatch({ type: setAllRecordsNeedsQaType, data });
        var code = initialState.allPatientCode;
        var id = initialState.allPatientId;
        dispatch({ type: setAllRecordsPatientType, code, id });
        id = initialState.allSiteId;
        var name = initialState.allSiteName;
        dispatch({ type: setAllRecordsSiteType, id, name });
        data = initialState.allStudyId;
        dispatch({ type: setAllRecordsStudyIdType, data });
        data = initialState.billableItem;
        dispatch({ type: setBillableItemType, data });
        data = initialState.allStudyName;
        dispatch({ type: setAllRecordsStudyNameType, data });
        data = initialState.allUnread;
        dispatch({ type: setAllRecordsUnreadType, data });
        data = initialState.allHistoryRecords;
        dispatch({ type: setAllHistoryRecordsType, data });
    },

    setRefresh: (setOn) => async (dispatch) => {
		dispatch({ type: setRecordsDoRefreshType, setOn });
    },
				
    set: (data) => async (dispatch) => {
        setResponse(data, dispatch, setRecordType);
    },

    setAll: (data) => async (dispatch) => {
        dispatch({ type: setAllRecordsType, data });
    },

    setAllNeedsOverread: (data) => async (dispatch) => {
        dispatch({ type: setAllRecordsNeedsOverreadType, data });
    },

    setAllNeedsQa: (data) => async (dispatch) => {
        dispatch({ type: setAllRecordsNeedsQaType, data });
    },

    setAllRejectedByMD: (data) => async (dispatch) => {
        dispatch({ type: setAllRecordsRejectedByMD, data });
    },

    setRecordIsScheduled: (data) => async (dispatch) => {
		dispatch({ type: setRecordIsScheduledType, data });
	},

    setRecordScheduleOrdinal: (data) => async (dispatch) => {
		dispatch({ type: setRecordScheduleOrdinalType, data });
	},

    setRecordSchedulePeriod: (data) => async (dispatch) => {
		dispatch({ type: setRecordSchedulePeriodType, data });
	},

    setAllPatient: (code, id) => async (dispatch) => {
        dispatch({ type: setAllRecordsPatientType, code, id });
    },

    setAllSite: (id, name) => async (dispatch) => {
        dispatch({ type: setAllRecordsSiteType, id, name });
    },

    setAllStudyName: (data) => async (dispatch) => {
        dispatch({ type: setAllRecordsStudyNameType, data });
    },

    setAllUnread: (data) => async (dispatch) => {
        dispatch({ type: setAllRecordsUnreadType, data });
    },


    updateBillableItem: (obj) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

		if ( obj.itemId === '' ) {
			obj.itemId = '00000000-0000-0000-0000-000000000000';
		}

        const url = await Fetch.getUrl(`Records/UpdateBillableItem`);
        const body = JSON.stringify({
			"id": obj.itemId,
			"studyId": obj.studyId,
			"qty": obj.qty,
			"code": obj.code,
			"description": obj.description,
			"isUorM": obj.isUorM,
			"price": obj.price,
			"amount": obj.amount,
		});
        await Fetch.putRequest(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    },

    updateBillableStatuses: (obj) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/UpdateBillableStatuses`);
        const body = JSON.stringify(obj);
        await Fetch.putRequest(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    },

    finalizeBill: (obj) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/FinalizeBill`);
        const body = JSON.stringify(obj);
        await Fetch.putRequest(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    },

    updateEvent: () => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, true, dispatch)) {
            return;
        }

        const record = recordsState.record;
        const url = await Fetch.getUrl(`Records/UpdateRecordEvent?id=${record.record.id}`);
        const receiveDateTime = utility.getDateTimeJson(record.record.receiveDateTime);
        const recordDateTime = utility.getDateTimeJson(record.record.recordDateTime);
        const body = JSON.stringify({
			hasAfib30: record.hasAfib30,
			hasAflutter30: record.hasAflutter30,
			hasAtachy30: record.hasAtachy30,
            record: {
                comments: record.record.comments,
        		predominantRhythm: record.record.predominantRhythm,
        		hasAfib: record.record.hasAfib,
        		hasAflutter: record.record.hasAflutter,
        		hasAtachy: record.record.hasAtachy,
        		isAnalyzable: record.record.isAnalyzable,
        		isMdNotification: record.record.isMdNotification,
                deviceModel: record.record.deviceModel,
                deviceSerial: record.record.deviceSerial,
                isMdOverreadRequired: record.record.isMdOverreadRequired,
                isQaRequired: record.record.isQaRequired,
                isScheduled: record.record.isScheduled,
                isSymptomatic: record.record.isSymptomatic,
                receiveDateTime: receiveDateTime,
                recordDateTime: recordDateTime,
                timeZoneOffsetMinutes: record.record.timeZoneOffsetMinutes
            }
        });
        await Fetch.putRequest(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    },

    updateHolter: () => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, true, dispatch)) {
            return;
        }

        const record = recordsState.record;
        const url = await Fetch.getUrl(`Records/UpdateRecordHolter?id=${record.record.id}`);
        const receiveDateTime = utility.getDateTimeJson(record.record.receiveDateTime);
        const recordDateTime = utility.getDateTimeJson(record.record.recordDateTime);
        const body = JSON.stringify({
            description: record.description,
            findings: record.findings,
        	afibLongestDuration: utility.getDurationFromHms(record.afibLongestDuration),
        	aflutterLongestDuration: utility.getDurationFromHms(record.aflutterLongestDuration),
        	atachyLongestDuration: utility.getDurationFromHms(record.atachyLongestDuration),
        	analyzableDuration: utility.getDurationFromHm(record.analyzableDuration),
        	totalDuration: utility.getDurationFromHm(record.totalDuration),
            record: {
                comments: record.record.comments,
        		predominantRhythm: record.record.predominantRhythm,
        		hasAfib: record.record.hasAfib,
        		hasAflutter: record.record.hasAflutter,
        		hasAtachy: record.record.hasAtachy,
        		isAnalyzable: record.record.isAnalyzable,
        		isMdNotification: record.record.isMdNotification,
                deviceModel: record.record.deviceModel,
                deviceSerial: record.record.deviceSerial,
                isMdOverreadRequired: record.record.isMdOverreadRequired,
                isQaRequired: record.record.isQaRequired,
                isScheduled: record.record.isScheduled,
                isSymptomatic: record.record.isSymptomatic,
                receiveDateTime: receiveDateTime,
                recordDateTime: recordDateTime,
                timeZoneOffsetMinutes: record.record.timeZoneOffsetMinutes
            }
        });
        await Fetch.putRequest(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    },

    updateRecordCrf: (serviceType, id, crfQnA) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/UpdateRecordCrf?id=${id}`);
        const body = JSON.stringify( { "CrfQnA": JSON.stringify(crfQnA) } );
        await Fetch.putRequest(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    },

    updateRecordIsMdOverreadRequired: (id, value) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/UpdateRecordIsMdOverreadRequired?id=${id}`);
        const body = JSON.stringify({
            isMdOverreadRequired: value
        });
        await Fetch.putRequest(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    },

    updateRecordIsQaRequired: (id, value) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/UpdateRecordIsQaRequired?id=${id}`);
        const body = JSON.stringify({
            isQaRequired: value
        });
        await Fetch.putRequest(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    },

    updateRecordIsScheduled: (id, value) => async (dispatch, getState) => {
        const accountsState = getState().accounts;

        const url = await Fetch.getUrl(`Records/UpdateRecordIsScheduled?id=${id}`);
        const body = JSON.stringify({
            isScheduled: value
        });
        await Fetch.putRequest(url, body, accountsState.authenticatedToken);
		dispatch({ type: setRecordIsScheduledType, value });
    },

    updateRecordIsSymptomatic: (id, value) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/UpdateRecordIsSymptomatic?id=${id}`);
        const body = JSON.stringify({
            isSymptomatic: value
        });
        await Fetch.putRequest(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    },

    updateRecordMdOverreadAssigned: () => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, true, dispatch)) {
            return;
        }

        const record = recordsState.record.record;
        const url = await Fetch.getUrl(`Records/UpdateRecordMdOverreadAssigned?id=${record.id}`);
        const body = JSON.stringify({
            mdOverreadAssignedId: record.mdOverreadAssignedId
        });
        await Fetch.putRequest(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    },

    updateRecordMdOverreadFindings: (id, value) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/UpdateRecordMdOverreadFindings?id=${id}`);
        const body = JSON.stringify({
            mdOverreadFindings: value
        });
        await Fetch.putRequest(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    },

    updateRecordMdRejection: (id, mdRejectionReason) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/UpdateRecordMdRejection?id=${id}`);
        const body = JSON.stringify({
            RejectionReason: mdRejectionReason
        });
        await Fetch.putRequest(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    },

    updateRecordScheduleOrdinal: (id, scheduleOrdinal, schedulePeriod) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const url = await Fetch.getUrl(`Records/updateRecordScheduleOrdinal?id=${id}`);

        const body = JSON.stringify({
            scheduleOrdinal: scheduleOrdinal,
            schedulePeriod: schedulePeriod
        });

        await Fetch.putRequest(url, body, accountsState.authenticatedToken);
    },

    updateRecordScheduleSuffix: (id, scheduleSuffix) => async (dispatch, getState) => {
        const accountsState = getState().accounts;

        const url = await Fetch.getUrl(`Records/updateRecordScheduleSuffix?id=${id}`);
        const body = JSON.stringify({
            scheduleSuffix: scheduleSuffix
        });
        await Fetch.putRequest(url, body, accountsState.authenticatedToken);
    },

    updateRecordQa: (id,isComplete) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/UpdateRecordQa?id=${id}&isComplete=${isComplete}`);
        await Fetch.putRequest(url, "", accountsState.authenticatedToken);
        setFetching(false, dispatch);
    },

    update12Lead: () => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, true, dispatch)) {
            return;
        }

        const record = recordsState.record;
        const url = await Fetch.getUrl(`Records/UpdateRecord12Lead?id=${record.record.id}`);
        const receiveDateTime = utility.getDateTimeJson(record.record.receiveDateTime);
        const recordDateTime = utility.getDateTimeJson(record.record.recordDateTime);
        const body = JSON.stringify({
            hr: record.hr,
            pAxis: record.pAxis,
            pr: record.pr,
            qrs: record.qrs,
            qt: record.qt,
            qtc: record.qtc,
            qtcB: record.qtcB,
            qtcF: record.qtcF,
            rAxis: record.rAxis,
			hasAfibContinuous: record.hasAfibContinuous,
			hasAflutterContinuous: record.hasAflutterContinuous,
			hasAtachyContinuous: record.hasAtachyContinuous,
            record: {
                comments: record.record.comments,
        		predominantRhythm: record.record.predominantRhythm,
        		hasAfib: record.record.hasAfib,
        		hasAflutter: record.record.hasAflutter,
        		hasAtachy: record.record.hasAtachy,
        		isAnalyzable: record.record.isAnalyzable,
        		isMdNotification: record.record.isMdNotification,
                deviceModel: record.record.deviceModel,
                deviceSerial: record.record.deviceSerial,
                isMdOverreadRequired: record.record.isMdOverreadRequired,
                isQaRequired: record.record.isQaRequired,
                isScheduled: record.record.isScheduled,
                isSymptomatic: record.record.isSymptomatic,
                receiveDateTime: receiveDateTime,
                recordDateTime: recordDateTime,
                timeZoneOffsetMinutes: record.record.timeZoneOffsetMinutes
            },
            rr: record.rr,
            tAxis: record.tAxis
        });
        await Fetch.putRequest(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    },

    uploadReport: (file, recordId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const recordsState = getState().records;
        if (badState(accountsState, recordsState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Records/AddReportToRecord?id=${recordId}`);
        var body = new FormData();
        body.append("file", file);
        await Fetch.postForm(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    }
};

function appendToForm(form, name, value) {
    if (value != null) {
        form.append(name, value);
    }
}

function badState(accountsState, recordsState, checkRecord, dispatch) {

	let waitUntil = Date.now() + 1*1000;
    while (accountsState == null || recordsState == null || recordsState.fetching) {
		if ( Date.now() > waitUntil ) {
			console.log(`badState() ${accountsState == null} || ${recordsState == null} || fetching=${recordsState && recordsState.fetching} then is badState`);
			return true;
		}
    }

    if (checkRecord && (
        recordsState.record == null ||
        recordsState.record.record == null)) {
        console.log('badState() - other');
        return true;
    }

    console.log('good state');
    setFetching(true, dispatch);
    return false;
}

function disposeReportInternal(report, dispatch) {
    if (report != null) {
        URL.revokeObjectURL(report);
        const data = null;
        dispatch({ type: setReportType, data });
    }
}

function setAllRecordsStudyId(data, dispatch) {
    dispatch({ type: setAllRecordsStudyIdType, data });
}

function setRecentScheduleOrdinalPeriod(data, dispatch) {
    dispatch({ type: setRecentScheduleOrdinalPeriodType, data });
}

function setFetching(data, dispatch) {
    dispatch({ type: setRecordsFetchingType, data });
}

function setResponse(data, dispatch, type) {
    Fetch.setResponse(data, dispatch, type, setRecordsFetchingType);
}

function setAllHistoryRecords(data, dispatch) {
    dispatch({ type: setAllHistoryRecordsType, data });
}

export function setAllCompliancyRows(data, dispatch) {
    dispatch({ type: setAllCompliancyRowsType, data });
}

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === setAllRecordsType) {
        return {
            ...state,
            all: action.data
        };
    }

    if (action.type === setRecentScheduleOrdinalPeriodType) {
        return {
            ...state,
            lastScheduleOrdinal: action.data.item1,
            lastSchedulePeriod: action.data.item2
        };
    }

    if (action.type === setAllBillablesType) {
        return {
            ...state,
            all: action.data.recordList,
			billableItems: action.data.billableItems,
        };
    }

    if (action.type === setAllHistoryRecordsType) {
        return {
            ...state,
            recordHistory: action.data
        };
    }

    if (action.type === setAllRecordsRejectedByMD) {
        return {
            ...state,
            allRejectedByMD: action.data
        };
    }

    if (action.type === setAllRecordsNeedsOverreadType) {
        return {
            ...state,
            allNeedsOverread: action.data
        };
    }

    if (action.type === setAllRecordsNeedsQaType) {
        return {
            ...state,
            allNeedsQa: action.data
        };
    }

    if (action.type === setAllRecordsPatientType) {
        return {
            ...state,
            allPatientCode: action.code,
            allPatientId: action.id
        };
    }

    if (action.type === setAllRecordsSiteType) {
        return {
            ...state,
            allSiteId: action.id,
            allSiteName: action.name
        };
    }

    if (action.type === setAllCompliancyRowsType) {
        return {
            ...state,
            allCompliancyRows: action.data,
            allCompliancyStudyId: action.data.studyId,
        };
    }

    if (action.type === setAllRecordsStudyIdType) {
        console.log('setting setAllRecordsStudyIdType:' + action.data);
        return {
            ...state,
            allStudyId: action.data
        };
    }

    if (action.type === setBillableItemType) {
        return {
            ...state,
            billableItem: action.data
        };
    }

    if (action.type === setAllRecordsStudyNameType) {
        return {
            ...state,
            allStudyName: action.data
        };
    }

    if (action.type === setAllRecordsUnreadType) {
        return {
            ...state,
            allUnread: action.data
        };
    }

    if (action.type === setRecordType) {
        return {
            ...state,
            record: action.data
        };
    }

	if ( action.type === setRecordIsScheduledType ) {
		return {
			...state,
			isScheduled: action.data
		};
	}

	if ( action.type === setRecordScheduleOrdinalType ) {
		return {
			...state,
			scheduleOrdinal: action.data
		};
	}

	if ( action.type === setRecordSchedulePeriodType ) {
		return {
			...state,
			schedulePeriod: action.data
		};
	}

	if ( action.type === setDownloadableDataType ) {
		return {
			...state,
			dataXls: action.data
		};
	}

    if (action.type === setRecordsFetchingType) {
        return {
            ...state,
            fetching: action.data
        };
    }

    if (action.type === setRecordsDoRefreshType) {
        return {
            ...state,
            doRefresh: action.setOn
        };
    }

    if (action.type === setReportType) {
        return {
            ...state,
            report: action.data
        };
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/store/Records.js